import React from 'react';
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001734599274.jpg';
import '../../styles/about.css';

const TaniTedavi6 = () => {
    return (
        <div>
            <h5 className='main-title'>KRİOTERAPİ</h5>
            <hr />
            <p>Kriyoterapi, Mısırlılar ve Hipokrat zamanından beri uygulanan bir tedavi biçimidir. Dondurma, kar ya da soğuk tedavisi olarak da bilinir. Uygulanan bölgede hastalıklı dokuları yok etmek için doku harabiyetine neden olarak etkisini gösterir.</p>
            <p>Dondurma işleminde kullanılacak olan gaz, prob içinden geçirilir ve probun ucunun aşırı derecede soğumasına neden olur. Soğutmada kullanılan gaz basınç ile probun ucuna itildiğinde, gaz aniden hacim olarak genişler ve etraftan ısı çekerken probun ucu soğur. Soğuk etkisiyle hücre içindeki ve dışındaki saf su, buz kristalleri haline getirilerek hücrenin ölümü meydana gelir.</p>
            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />
            <p>Bunun için -78,5°C’de katı karbon dioksit (kuru buz), -190°C sıvı azot, florokarbon ve nitrözoksit gibi kriyojen maddeler kullanılır. Gümüş ya da bakırdan yapılmış kriyokoter adlı aletlerle de dokulara soğuk uygulanır.</p>

        </div>
    );
};

export default TaniTedavi6;
